import {
  AppState,
  AppStateMachineContext,
  AppStateMachineMeta,
} from '../types';

export function contextSelector(state: AppState): AppStateMachineContext {
  return state.context;
}

export function metaSelector(state: AppState): AppStateMachineMeta {
  return Object.values(state.meta as AppStateMachineMeta)
    .reduce(
      (acc, metaValue) => Object.assign(acc, metaValue),
      {} as AppStateMachineMeta,
    );
}

export function canGoBackSelector(state: AppState): boolean {
  return state.can('PREVIOUS');
}

export function canGoToWelcomeSelector(state: AppState): boolean {
  return state.can('GO_WELCOME');
}

export function isInvalidOtpSelector(state: AppState): boolean {
  return state.event.type === 'INVALID_OTP_CODE';
}

export function isInvalidPhoneNumberSelector(state: AppState): boolean {
  return state.event.type === 'INVALID_PHONE_NUMBER';
}

export function isErrorSelector(state: AppState): boolean {
  return state.hasTag('error');
}

export function isLoadingSelector(state: AppState): boolean {
  return state.hasTag('loading');
}

export function isBusySelector(state: AppState): boolean {
  return state.hasTag('busy');
}

export function isDraftSelector(state: AppState): boolean {
  return state.hasTag('draft');
}

export const isMfEnabledSelector = (mf: string) => (state: AppState): boolean => state.hasTag(`MF:${mf}`);

export function isSpinnerLoadingSelector(state: AppState): boolean {
  return state.hasTag('isSpinnerLoading');
}
